import { FeatureMiddleware } from '@cast/api-client';

import {
  getIsOpDemoMode,
  setHasDiscoveredClusters,
} from '@cast/infrastructure-demo';

import { opDemoLoader } from '../utils';

export const inventory: FeatureMiddleware<'inventory'> = {
  getAssetListClusters: async ({ next, resolve, endpoint, feature }) => {
    const response = await next();

    const discoveredClusters = response.data?.items ?? [];
    const hasDiscoveredClusters = discoveredClusters.length > 0;

    setHasDiscoveredClusters(hasDiscoveredClusters);

    if (getIsOpDemoMode()) {
      const fixture = await opDemoLoader.loadFixture({
        feature,
        endpoint,
      });

      if (fixture) {
        return resolve(fixture);
      }
    }

    return response;
  },
};
